export const Env = import.meta.env.VITE_API_ENV;
export const Base_url =
  Env === 'local'
    ? `${import.meta.env.VITE_API_URL_DEV}/api/`
    : `${import.meta.env.VITE_API_URL_PROD}/api/`;
export const secretKey = import.meta.env.VITE_API_SECRET_KEY;
export const projectId = import.meta.env.VITE_API_PROJECT_ID;
